module.exports = __webpack_public_path__ + "passport/img/lhv2DA.9b2066e7.png";